import upperFirst from 'lodash/upperFirst';

export const adaptRelationValue = (name, list) => {
  const target = list.find(label => label === name);

  return target
    ? {
        label: upperFirst(target),
        value: target,
      }
    : null;
};



// WEBPACK FOOTER //
// ./src/utils/forms/EmergencyContact/adaptRelationValue.js